import fetcher from '../fetcher'

import type { Event, EventFilters, EventType } from './types'
import config from '../../config'
import { IResponseBody } from '../types'
import * as eventUtils from '../../libraries/events'

export const getEvent = async (id: number): Promise<Event> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/events/${id}`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching event: ${error}`)
    throw error
  }
}

export const getEvents = async ({ params, limit } : { params?: Partial<EventFilters>, limit?: number }): Promise<Array<Event>> => {
  try {
    const urlParams = new URLSearchParams(params as Record<string, string>)
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/events/?${urlParams}${limit ? `&limit=${limit}`: ''}`, {
      method: 'GET'
    })
    if(res.data) {
      return eventUtils.sortEventsByDate(res.data) as Array<Event>
    }
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching events: ${error}`)
    throw error
  }
}

export const getAllEventTypes = async (): Promise<Array<EventType> | undefined> => {
	try {
		const res: IResponseBody<Array<EventType>> = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/events/types`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
    console.error(`Error fetching event types: ${error}`)
		throw error
	}
}

export const rsvpEvent = async (_: string, { arg }: { arg: { eventId: number, rsvpStatus: boolean } }): Promise<Partial<Event>> => {
  try {
    const rest = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/events/${arg.eventId}/rsvp`, {
      method: 'PATCH',
      body: JSON.stringify({ rsvpStatus: arg.rsvpStatus })
    })
    return rest.data
  } catch (error: unknown) {
    console.error(`Error RSVPing to event: ${error}`)
    throw error
  }
}
